import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Style from "./SidebarMenu.module.scss";
import { getInfoAPI, LogoutAPI } from "../../../Api/PanelAdminServices";
import { errorToast } from "../../../Utils/Toast/Toast";
import { getSidebarMenuItems } from "./menuConfig";
import SidebarAccordionItem from "./SidebarAccordionItem/SidebarAccordionItem";
import { BoxArrowRight } from "react-bootstrap-icons";

const SidebarMenu = () => {
  const [info, setInfo] = useState({});
  const location = useLocation();

  useEffect(() => {
    getAdminInfo();
  }, []);

  const LogoutHandler = () => {
    const logoutPayload = { logout: "" };
    LogoutAPI(logoutPayload, (succ) => {
      if (succ?.status === 1 || succ?.status === 0) {
        localStorage.clear();
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        errorToast("مشکلی پیش آمده است");
      }
    });
  };

  const getAdminInfo = async () => {
    getInfoAPI((succ, res) => {
      if (succ) {
        if (res?.status === 0 || res?.status === -2) {
          errorToast("مشکلی پیش آمده است");
          LogoutHandler();
        } else {
          setInfo(res?.admin || {});
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
        LogoutHandler();
      }
    });
  };

  const menuItems = getSidebarMenuItems(info);
  const adminName =
    info?.first_name || info?.last_name
      ? `${info?.first_name || ""} ${info?.last_name || ""}`.trim()
      : "مدیر سامانه";

  return (
    <aside className={Style.componentHandler} dir="rtl">
      {/* Profile Header */}
      <div className={Style.userInfo}>
        <div className={Style.profileRight}>
          <div className={Style.imgWrapper}>
            <img
              src="Assets/Images/Profile/img.jpg"
              alt="پروفایل کاربر"
              onError={(e) => {
                // fallback if image not found
                e.target.src =
                  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 24 24' fill='%23999'><path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/></svg>";
              }}
            />
          </div>

          <div className={Style.namePhone}>
            <h2 className={Style.name}>{adminName}</h2>
            <h3 className={Style.phone}>{info?.phone || "—"}</h3>
          </div>
        </div>

        <button
          className={Style.logoutBtn}
          onClick={LogoutHandler}
          title="خروج از حساب"
        >
          <BoxArrowRight />
        </button>
      </div>

      {/* Accordion Menu List */}
      <div className={Style.menuList}>
        {menuItems.map((item) => (
          <SidebarAccordionItem
            key={item.id}
            item={item}
            currentPath={location?.pathname}
          />
        ))}
      </div>
    </aside>
  );
};

export default SidebarMenu;
